module.exports = __webpack_public_path__ + "static/media/poweredby.a44f6eac.svg";